<script lang="ts">
    export let src: string;
    export let srcset: string = '';
    export let width: number = null;
    export let height: number = null;
    export let description = '';
</script>

<section class="grid place-content-center lg:max-h-[80vh]">
    <figure class="flex h-full flex-col gap-1 text-center lg:max-w-[90vw] lg:flex-row">
        <img
            class="max-h-[80vh] w-auto shrink object-contain"
            {src}
            {srcset}
            {width}
            {height}
            alt={description}
            loading="lazy"
        />
        {#if description}
            <div class="lg:writing-mode-bt max-h-[80vh] text-center text-xs leading-3 lg:py-5">
                {description}
            </div>
        {/if}
    </figure>
</section>

<style>
    section {
        grid-column: full;
    }
</style>
